import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-item accordion-layout nested-nav" }
const _hoisted_3 = ["data-bs-target", "aria-controls"]
const _hoisted_4 = { class: "me-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["id", "data-bs-parent"]

import { ref, computed, watch } from 'vue'
import NavElement from './NavElement.vue'
import arrow from '@/assets/svg/arrow.svg'
import MsButton from '@/components/general/buttons/MsButton.vue'
import { ButtonSize } from '@/utilities/enums'
import NestedNavElement from './NestedNavElement.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NestedNavItem',
  props: {
  name: String,
  href: String,
  isExpanded: Boolean
},
  emits: ['expand'],
  setup(__props, { emit: __emit }) {

var props = __props

const emit = __emit

const navAccordion = ref()
const navAccordionData = ref()

const accordionOuterId = ref('nav-item-outer-' + props.name)

const accordionInnerId = ref('nav-item-inner-' + props.name)

const isNavAccordionOpen = ref(false)
const isNavItemActive = ref(false)

const toggle = () => {
  if (!props.isExpanded && !isNavAccordionOpen.value) {
    emit('expand')
  }
  isNavAccordionOpen.value = !isNavAccordionOpen.value
}

const justifyClass = computed(
  () => `${props.isExpanded ? 'justify-content-between' : 'justify-content-center'}`
)

const setActive = (isActive: boolean) => {
  isNavItemActive.value = isActive
}

watch(
  () => props.isExpanded,
  (newVal) => {
    if (!newVal && isNavAccordionOpen.value) {
      navAccordion.value.click()
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    id: accordionOuterId.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "navAccordion",
        ref: navAccordion,
        class: _normalizeClass(["d-flex align-items-center accordion-layout-inner mt-1", [justifyClass.value, { active: isNavItemActive.value }]]),
        onClick: toggle,
        "data-bs-toggle": "collapse",
        "data-bs-target": '#' + accordionInnerId.value,
        "aria-expanded": "false",
        "aria-controls": accordionInnerId.value
      }, [
        _createElementVNode("div", null, [
          _createVNode(NavElement, {
            name: __props.name,
            href: __props.href,
            "is-expanded": __props.isExpanded,
            "hoverand-active-bg": "none"
          }, null, 8, ["name", "href", "is-expanded"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(MsButton, {
            "data-bs-toggle": "collapse",
            "data-bs-target": '#' + accordionInnerId.value,
            "aria-expanded": "false",
            "aria-controls": accordionInnerId.value,
            "button-size": _unref(ButtonSize).NoPadding
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(arrow),
                class: _normalizeClass([{ rotated: isNavAccordionOpen.value }, "icon ms-rotate-icon"])
              }, null, 10, _hoisted_5)
            ]),
            _: 1
          }, 8, ["data-bs-target", "aria-controls", "button-size"])
        ], 512), [
          [_vShow, __props.isExpanded]
        ])
      ], 10, _hoisted_3),
      _createElementVNode("div", {
        ref_key: "navAccordionData",
        ref: navAccordionData,
        id: accordionInnerId.value,
        class: "accordion-collapse collapse",
        "data-bs-parent": '#' + accordionOuterId.value
      }, [
        _createVNode(NestedNavElement, {
          name: "Profile",
          href: __props.href + '/profile',
          "is-expanded": __props.isExpanded,
          onIsActive: setActive
        }, null, 8, ["href", "is-expanded"]),
        _createVNode(NestedNavElement, {
          name: "Organisations",
          href: __props.href + '/organisations',
          "is-expanded": __props.isExpanded,
          onIsActive: setActive
        }, null, 8, ["href", "is-expanded"]),
        _createVNode(NestedNavElement, {
          name: "Projects",
          href: __props.href + '/projects',
          "is-expanded": __props.isExpanded,
          onIsActive: setActive
        }, null, 8, ["href", "is-expanded"]),
        _createVNode(NestedNavElement, {
          name: "Alarms",
          href: __props.href + '/alarm/configurations',
          "is-expanded": __props.isExpanded,
          onIsActive: setActive
        }, null, 8, ["href", "is-expanded"])
      ], 8, _hoisted_6)
    ])
  ], 8, _hoisted_1))
}
}

})